import { MutationTree } from 'vuex';

import { Errors, Photo, Steps } from '@/@types';

import { State } from './state';
import { MutationTypes } from './mutation-types';

export type Mutations<S = State> = {
  [MutationTypes.SET_PHOTO](state: S, payload: Photo): void;
  [MutationTypes.SET_STEP](state: S, payload: Steps): void;
  [MutationTypes.SET_LOADING](state: S, payload: boolean): void;
  [MutationTypes.SET_RETURN_URL](state: S, payload: string): void;
  [MutationTypes.SET_ERROR](state: S, payload: Errors): void;
  [MutationTypes.SET_DOCUMENT](state: S, payload: Photo): void;
  [MutationTypes.SET_SESSIONTYPE](state: S, payload: string): void;
}

export const mutations: MutationTree<State> & Mutations = {
  [MutationTypes.SET_PHOTO](state: State, photo: Photo) {
    state.photo = photo;
  },
  [MutationTypes.SET_STEP](state: State, step: Steps) {
    state.step = step;
  },
  [MutationTypes.SET_LOADING](state: State, isLoading: boolean) {
    state.isLoading = isLoading;
    state.isLoadingDocument = isLoading
  },
  [MutationTypes.SET_RETURN_URL](state: State, returnUrl: string) {
    state.returnUrl = returnUrl;
  },
  [MutationTypes.SET_ERROR](state: State, error: Errors) {
    state.error = error;
  },
  [MutationTypes.SET_DOCUMENT](state: State, document: Photo) {
    state.document = document;
  },
  [MutationTypes.SET_SESSIONTYPE](state: State, sessionType: string) {
    state.sessionType = sessionType;
  },
};
